import http from '../../http-common';

class EventPracticeService {
	create(data) {
		return http.post('/promoter/eventDetails/practice', data);
	}

    getAll(eventId) {
        return http.get(`/promoter/eventDetails/${eventId}/practice/`);
    }

	update(data) {
		return http.put('/promoter/eventDetails/practice', data);
	}

	delete($eventId, $practiceId) {
		return http.delete(`/promoter/eventDetails/${$eventId}/practice/${$practiceId}`);
	}
}

export default new EventPracticeService();
